// extracted by mini-css-extract-plugin
export default {"container":"Politcs_container__MZZQy","primaryColor":"Politcs_primaryColor__DFLPw","navUl":"Politcs_navUl__ZZY78","navLi":"Politcs_navLi__7uTfs","navBlock":"Politcs_navBlock__7GLQU"};